import { createActions, createReducer } from "reduxsauce";

import Immutable from "seamless-immutable";

/*
Global application types and creators

https://github.com/skellock/reduxsauce#createactions

import { Types, Creators } from '../actions';

 */

export const { Types, Creators } = createActions({
  // Log in
  loginRequest: ["username", "password", "location", "mode"],
  loginFailed: ["code", "message"],
  loginSucceeded: ["location", "mode", "user"],

  // Log out
  logout: null,
  logoutSucceeded: null,
  logoutFailed: null,

  // Create user
  createUserRequest: ["username", "password", "email"],
  createUserFailed: null,
  createUserSucceeded: null
});

/*
Initial State
 */
const initialState = Immutable({
  loginFailedMessage: "",
  loginFailedCode: "",
  user: null,
  mode: localStorage.getItem("mode") || null,
  location: localStorage.getItem("location") || null,
  username: localStorage.getItem("username") || null
});

/*
Reducer Functions
 */

const resetLogin = (state = initialState, action) =>
  Immutable.merge(state, initialState);

const onLoginFailed = (state = initialState, action) => {
  const { code, message } = action;

  return Immutable.merge(state, {
    loginFailedCode: code,
    loginFailedMessage: message
  });
};

const onLoginSucceeded = (state = initialState, action) => {
  const { location, mode, user } = action;

  return Immutable.merge(state, {
    location,
    mode,
    user
  });
};

/*
Reducer
 */

export default createReducer(initialState, {
  [Types.LOGIN_REQUEST]: resetLogin,
  [Types.LOGOUT]: resetLogin,
  [Types.LOGIN_FAILED]: onLoginFailed,
  [Types.LOGIN_SUCCEEDED]: onLoginSucceeded
});



// WEBPACK FOOTER //
// ./src/login/reducer.js